import {
  ConditionalOperatorArray,
  ConditionalOperatorPrimitive,
  SchemaIncidentMainCause,
  type EvidenceDocumentRequirementRule,
} from '@/types';
import { documentTypeName } from './documentTypeName';
import { medicalConditionName } from './medicalConditionName';
import { schemaFieldName } from './schemaFieldName';

const { incident } = schemaFieldName;
const { illnessDetails } = incident;

const medicalFormExemptConditions = [
  medicalConditionName.acuteRespiratory,
  medicalConditionName.altitudeSickness,
  medicalConditionName.earEyeNoseOrThroatIllness,
  medicalConditionName.gastrointestinalIllness,
];

const evidenceDocumentRules: EvidenceDocumentRequirementRule[] = [
  {
    documentType: documentTypeName.medicalReport,
  },
  {
    documentType: documentTypeName.medicalForm,
    isRequiredWhen: [
      {
        field: incident.mainCause,
        value: SchemaIncidentMainCause.Illness,
        operator: ConditionalOperatorPrimitive.Equal,
      },
      {
        field: illnessDetails.medicalCondition,
        value: medicalFormExemptConditions,
        operator: ConditionalOperatorArray.NotIn,
      },
    ],
  },
  {
    documentType: documentTypeName.dentalReport,
    isRequiredWhen: [
      {
        field: incident.mainCause,
        value: SchemaIncidentMainCause.Dental,
        operator: ConditionalOperatorPrimitive.Equal,
      },
    ],
  },
  {
    documentType: documentTypeName.incidentReport,
    isRequiredWhen: [
      {
        field: incident.mainCause,
        value: SchemaIncidentMainCause.Injury,
        operator: ConditionalOperatorPrimitive.Equal,
      },
    ],
  },
];

function getEvidenceDocumentRules() {
  return evidenceDocumentRules;
}

export { getEvidenceDocumentRules };
